import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	avatarErrorModalGoBackButtonTitle: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.avatar-picker-modal.avatar-error-modal.avatar-error-modal-go-back-button-title',
		defaultMessage: 'Go back',
		description: 'Button title to return to previous modal screen',
	},
});
